import { render } from "react-dom";
import { useEffect } from "react";

const ExpandoButton = ({ text }) => {
  let splitButton = [];

  if (text?.toString().includes("||")) {
    splitButton = text.split("||");
  }

  return (
    <>
      {/* if this is a normal text button */}
      {splitButton.length < 1 && Text}

      {/* if this is a button with an expanded hover */}
      {splitButton.length > 0 && (
        <>
          <span>{splitButton[0]}</span>
          <span>
            &nbsp;
            {splitButton[1]}
          </span>
        </>
      )}
    </>
  );
};

export const useExpandoButton = () => {
  useEffect(() => {
    const expandoButtons = Array.from(document.querySelectorAll(".g-exp"));

    expandoButtons.forEach((button) => {
      if (!button.innerHTML.toString().includes("||")) return;

      const buttonText = button.innerHTML.toString();
      button.classList.add("expandobutton");

      return render(<ExpandoButton text={buttonText} />, button);
    });
  }, []);
};
